import React from 'react'
import Banner from '../components/Banner'
import HomeContent from './HomeContent'
import HomeServices from '../components/HomeServices';
import Testimonial from './Testimonial';
import HomePlans from './HomePlans';

const Home = () => {
  return (
    <>
      <Banner/>
      <HomeContent/>
      <HomeServices/>
      <HomePlans/>
      <Testimonial/>
    </>
  )
}

export default Home